<template>
  <chart-card title="Cupons" filter-button :filter-type.sync="filterType" :data="chartData" :loader="['cupons']" is-currency legends />
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    listaCuponsMensal: [],
    listaCuponsSemanal: [],
    listaCuponsDiario: [],
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        profissional: this.$route.params.id,
      }
    },
    cuponsMensal() {
      return helpers.agrupamentoMensal(this.listaCuponsMensal, 'NUM_CUPONS_IDENTIFICADOS')
    },
    cuponsSemanal() {
      return helpers.agrupamentoSemanal(this.listaCuponsSemanal, 'NUM_CUPONS_IDENTIFICADOS')
    },
    cuponsDiario() {
      return helpers.agrupamentoDiario(this.listaCuponsDiario, 'NUM_CUPONS_IDENTIFICADOS')
    },
    cuponsIdentificadosMensal() {
      return helpers.agrupamentoMensal(this.listaCuponsMensal, 'NUM_CUPONS_TOTAL')
    },
    cuponsIdentificadosSemanal() {
      return helpers.agrupamentoSemanal(this.listaCuponsSemanal, 'NUM_CUPONS_TOTAL')
    },
    cuponsIdentificadosDiario() {
      return helpers.agrupamentoDiario(this.listaCuponsDiario, 'NUM_CUPONS_TOTAL')
    },
    cupons() {
      if (this.filterType === 'mensal') return this.cuponsMensal
      if (this.filterType === 'semanal') return this.cuponsSemanal
      if (this.filterType === 'diario') return this.cuponsDiario
      return ''
    },
    cuponsIdentificados() {
      if (this.filterType === 'mensal') return this.cuponsIdentificadosMensal
      if (this.filterType === 'semanal') return this.cuponsIdentificadosSemanal
      if (this.filterType === 'diario') return this.cuponsIdentificadosDiario
      return ''
    },
    chartData() {
      const arrayIdentificados = cloneDeep(this.cuponsIdentificados)
      const array = cloneDeep(this.cupons)
      if (arrayIdentificados.length > array.length) {
        const lengthDifference = arrayIdentificados.length - array.length
        for (let i = 0; i < lengthDifference; i++) {
          array.unshift({})
        }
      }
      return {
        labels: [...array.map((object) => object.data)],
        datasets: [
          {
            label: 'Cupons',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...array.map((object) => object.valor)],
            fill: false,
          },
          {
            label: 'Cupons Identificados',
            backgroundColor: colors[1],
            strokeColor: colors[1],
            borderColor: colors[1],
            data: [...arrayIdentificados.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  async mounted() {
    await this.getData()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getData)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      clubePercentualCuponsIdentificadosChart: 'cupons',
    }),
    getData() {
      this.clubePercentualCuponsIdentificadosChart({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
        this.listaCuponsMensal = data
      })
      this.clubePercentualCuponsIdentificadosChart({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
        this.listaCuponsSemanal = data
      })
      this.clubePercentualCuponsIdentificadosChart({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
        this.listaCuponsDiario = data
      })
    },
  },
}
</script>
